import store from './store'

/*################################################################
                        Bootstrap
################################################################*/
window.Vue = require('vue');

try {
    // safety loader
    if(!window.$) {
        window.$ = window.jQuery = require('jquery');
    }
    window.key = 'AIzaSyBN3OpoSKJ_frQTfcYpjAWC3XdLs6sGgck';
} catch (e) {}

Vue.config.productionTip = false;

import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
    load: {
        key: window.key,
        libraries: 'places', // This is required if you use the Autocomplete plugin
    },
});

window.axios = require('axios');

/*################################################################
                            Components
################################################################*/
import Questionary from './components/Questionary';

Vue.component('maps', require('./components/Maps.vue').default);
Vue.component('lightbox', require('./components/Lightbox.vue').default);


/*################################################################
                            Initiators
################################################################*/

if(document.getElementById('app')) {
    var app = new Vue({
        el:'#app',
        store,
        render: h => h(Questionary)
    });
}


// if(document.getElementById('locations')) {
//   var app = new Vue({
//     el:'#locations',
//   });
// }

